import React from "react";

export function SectionHeading({ overline, title, subtitle, align = "center" }) {
  const alignment = align === "left" ? "text-left mx-0" : "text-center mx-auto";
  return (
    <div className={`max-w-2xl ${alignment}`}>
      {overline ? (
        <p className="text-xs uppercase tracking-[0.18em] text-[#C9A96E]">{overline}</p>
      ) : null}
      <h2 className="mt-3 font-display text-3xl sm:text-4xl tracking-[-0.02em] text-foreground">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-4 text-sm md:text-base text-muted-foreground leading-relaxed">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
